import { FC } from 'react';

import { useCopyToClipboard } from '../../../../../hooks/use-copy-to-clipboard';
import { CopyIcon } from '../../../../icons';

import styles from './CopyToClipBoardCell.module.scss';

interface CopyToClipBoardCellProps {
  value: string;
}

export const CopyToClipBoardCell: FC<CopyToClipBoardCellProps> = ({ value }) => {
  const copyToClipboard = useCopyToClipboard();

  const handleCopyToClipBoard = (value: string, event: any) => {
    copyToClipboard(value);
    event.preventDefault();

    return false;
  };

  return (
    <div className={styles.transactionTextWrapper} onClick={(e) => handleCopyToClipBoard(value, e)}>
      <span className={styles.transactionText}>{value}</span> <CopyIcon />
    </div>
  );
};
